<template>
  <div class="service-info-header">
    <h1
      v-if="!isCard"
      id="page-title"
      class="service-title"
    >
      {{ serviceName }}
    </h1>
    <div
      v-else
      class="service-title--small"
    >
      {{ serviceName }}
    </div>
    <div
      v-if="canShowRatingInfo"
      class="service-rating"
    >
      <i class="service-rating__icon icon-star-filled" />
      <span class="service-rating__number">{{ ratingAverage }}</span>
      <span class="service-rating__text">(</span>
      <span class="service-rating__text service-rating__text--underline" @click="scrollToRating">{{ formatNumber(ratingAmount) }} 則評價</span>
      <span class="service-rating__text">)</span>
      <span
        v-if="canShowRatingInfo && canShowCompletedOrderInfo"
        class="service-rating__divider"
      />
      <span
        v-if="canShowCompletedOrderInfo"
        class="service-rating__text service-rating__text--gray"
      >
        {{ formatNumber(completedOrderCount) }} 位住戶已訂購
      </span>
    </div>
    <div
      v-if="!isCard && highlightTag.iconName"
      class="service-tag"
    >
      <i
        class="service-tag__icon"
        :class="[`icon-${highlightTag.iconName}`]"
      >
        <span class="path1" />
        <span class="path2" />
      </i>
      <span class="service-tag__text">{{ highlightTag.typeName }}</span>
    </div>
    <div
      v-if="!isNaN(recommendedSellingPrice)"
      class="service-price"
    >
      <span class="service-price__number">${{ formatPrice(recommendedSellingPrice) }}</span>
      <span class="service-price__text">起</span>
    </div>
    <div
      v-else
      class="service-price__number"
    >
      {{ recommendedSellingPrice }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceInfoHeader',
  props: {
    serviceName: {
      type: String,
      required: true
    },
    ratingAverage: {
      type: Number,
      default: 0
    },
    ratingAmount: {
      type: Number,
      default: 0
    },
    completedOrderCount: {
      type: Number,
      default: 0
    },
    recommendedSellingPrice: {
      type: [String, Number],
      default: ''
    },
    // 是否為 stickyCard
    isCard: {
      type: Boolean,
      default: false
    },
    highlightTag: {
      type: Object,
      default: () => ({
        iconName: '',
        typeName: ''
      })
    }
  },
  computed: {
    canShowRatingInfo () {
      return this.ratingAverage > 0
    },
    canShowCompletedOrderInfo () {
      return this.completedOrderCount > 0
    }
  },
  methods: {
    formatNumber (number) {
      if (number < 10000) {
        return number.toLocaleString()
      } else {
        const rounded = Math.floor(number / 10000)
        return rounded + '萬+'
      }
    },
    formatPrice (string) {
      return Number(string).toLocaleString()
    },
    scrollToRating () {
      this.$emit('scrollToRating')
    }
  }
}
</script>

<style scoped lang="scss">
.service-title {
  font-size: pxTorem(32px);
  font-weight: 600;
  margin-bottom: 10px;
  &--small {
    font-size: pxTorem(25px);
    font-weight: 600;
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 768px) {
  .service-title {
    font-size: pxTorem(18px);
  }
}

.service-rating {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  &__icon {
    font-size: pxTorem(18px);
    color: #ffc107;
  }
  &__number {
    font-size: pxTorem(18px);
    font-weight: 600;
    margin-left: pxTorem(8px);
    margin-right: pxTorem(8px);
  }
  &__text {
    &--gray {
      color: $darkGrayColor;
    }
    &--underline {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  &__divider {
    margin: 0 5px;
    height: 15px;
    border-right: 2px solid $darkGrayColor;
    opacity: 0.5;
  }
}

@media screen and (max-width: 768px) {
  .service-rating {
    &__icon {
      font-size: 16px;
    }
    &__number {
      font-size: 16px;
    }
    &__text {
      font-size: 13px;
    }
  }
}

.service-tag {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 4px;
  background-color: $mainColor;
  width: fit-content;
  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
  }
  &__text {
    font-size: 14px;
    font-weight: 600;
    color: #fff;
  }
}

.service-price {
  display: flex;
  align-items: flex-end;
  line-height: 1;
  margin-top: pxTorem(16px);
  &__number {
    font-size: pxTorem(25px);
    font-weight: 600;
    margin-right: 4px;
  }
  &__text {
    font-size: pxTorem(18px);
  }
}

@media screen and (max-width: 768px) {
  .service-title {
    font-size: 18px;
  }
  .service-rating {
    &__icon {
      font-size: 16px;
    }
    &__number {
      font-size: 16px;
    }
    &__text {
      font-size: 13px;
    }
  }
  .service-price {
    &__number {
      font-size: 21px;
    }
    &__text {
      font-size: 13px;
    }
  }
}
</style>
